// src/store/modules/profile.js
import axios from 'axios';

const state = {
  user: null,
  isLoading: false,
  profile: null,
};

const getters = {
  getUser: (state) => state.user,
  isLoading: (state) => state.isLoading,
  profile: state => state.profile,
};

const actions = {
  async fetchUserProfile({ commit }) {
    commit('setLoading', true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://apidash.smartpress.kz/api/userprofile', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      commit('setUser', response.data);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    } finally {
      commit('setLoading', false);
    }
  },
    async fetchProfile({ commit }, userId) {
        const token = localStorage.getItem('token');

        const { data } = await axios.get(
          `https://apidash.smartpress.kz/api/profile/${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // API отдаёт { profile: {...} }
        commit('SET_PROFILE', data.profile);
      }

 
};

const mutations = {
  setUser(state, userData) {
    state.user = userData.user;
    state.user.profile = userData.profile; // Directly set the profile data
    state.user.role_name = userData.role_name; // Set the role name
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
   SET_PROFILE(state, profile) {
    state.profile = profile;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
